import { hideCountry } from '@/components/PowerKitPreSale';
import InfoCollection from '@/components/PowerKitPreSale/components/PreOrder/infocollection';
import { toMM100GetQuote } from '@/components/PowerKitPreSale/components/PreOrder/InfoQuote/utils';
import SuccessDialog from '@/components/PowerKitPreSale/components/PreOrder/successDialog';
import { useStore } from '@/components/PowerKitPreSale/context';
import Image from '@/components/UI/Image';
import EFAlarmClockIcon from '@/components/UI/svg/Icons/EFAlarmClockIcon';
import EFAskMeIcon from '@/components/UI/svg/Icons/EFAskMeIcon';
import EFAvatorIcon from '@/components/UI/svg/Icons/EFAvatorIcon';
import EFRightArrow from '@/components/UI/svg/Icons/EFRightArrow';
import FacebookSvg from '@/components/UI/svg/Icons/FacebookSvg';
import LinkSvg from '@/components/UI/svg/Icons/LinkSvg';
import OutlookSvg from '@/components/UI/svg/Icons/OutlookSvg';
import TwitterSvg from '@/components/UI/svg/Icons/TwitterSvg';
import { actIdGetAccessFlow, actIdUpdateAccessFlow } from '@/service';
import { getWSSUrl } from '@/utils/countryRegion';
import wss from '@/utils/mqtt-client-powerkit';
import topics from '@/utils/mqtt-client-powerkit/crowd-funding-topics';
import { useGlobal } from '@/utils/useGlobal';
import { Button, message, Tooltip } from 'antd';
import { EmailShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';
import SwiperCore, { A11y, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import style from './index.module.scss';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

//开始时间和截止时间
const dateObjS: any = {
    us: process.env.NEXT_PUBLIC_MM100_US_DEADLINE_START,
    jp: process.env.NEXT_PUBLIC_MM100_JP_DEADLINE_START,
    kr: process.env.NEXT_PUBLIC_MM100_KR_DEADLINE_START,
    au: process.env.NEXT_PUBLIC_MM100_AU_DEADLINE_START,
};
const dateObjE: any = {
    us: process.env.NEXT_PUBLIC_MM100_US_DEADLINE_END,
    jp: process.env.NEXT_PUBLIC_MM100_JP_DEADLINE_END,
    kr: process.env.NEXT_PUBLIC_MM100_KR_DEADLINE_END,
    au: process.env.NEXT_PUBLIC_MM100_AU_DEADLINE_END,
};
function getDateObjS(locale: string) {
    return dateObjS[locale] || dateObjS['us'];
}
function getDateObjE(locale: string) {
    return dateObjE[locale] || dateObjE['us'];
}
const noStartLocaleArr: any = [];
const oneDayTimes = 1000 * 60 * 60 * 24;
//开始时间和截止时间--end

function formatFlow(val: string) {
    return (val || '0').toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}

export default function PreOrder({ activityId, preCallback }: any) {
    const { useState, gtm, useRouter, useEffect, useLang } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const presaleState = useStore();
    const router = useRouter();

    const swiperImgs: any = {
        us: [
            `/img/mm100/preview_h5/powerkits-banner1.jpg`,
            '/img/mm100/preview_h5/powerkits-banner2.jpg',
            '/img/mm100/preview_h5/powerkits-banner3.jpg',
            locale === 'cn' ? '/img/mm100/preview_h5/powerkits-banner4_cn.jpg' : '/img/mm100/preview_h5/powerkits-banner4.jpg',
            '/img/mm100/preview_h5/powerkits-banner5.jpg',
            locale === 'cn' ? '/img/mm100/preview_h5/powerkits-banner6_cn.jpg' : '/img/mm100/preview_h5/powerkits-banner6.jpg',
        ],
    };

    let locationHref = '';
    if (typeof window !== 'undefined') {
        locationHref = location.href;
    }

    //访问量--------start
    const [totalFlows, setTotalFlows] = useState('--');

    // 访问量--同步比较值，如果最新值比旧值少，则不更新
    const updateTotalFlows = (oldData: string, newData: string) => {
        const oldFlow = parseInt(oldData, 10) || 0;
        const newFlow = parseInt(newData, 10) || 0;
        //  可能存在取之延时，当值比上一个值大时才设置
        if (newFlow > oldFlow) {
            setTotalFlows(newData);
        }
    };

    // 访问量--最新访问量
    const getFlowsTimer = () => {
        actIdGetAccessFlow({
            activityId: activityId,
        }).then((res: any) => {
            if (res?.code === '0') {
                updateTotalFlows(totalFlows, res.data.totalFlow);
            }
        });
    };

    useEffect(() => {
        if (!activityId) return;
        getFlowsTimer();
        actIdUpdateAccessFlow({
            activityId: activityId,
        });
    }, [activityId]);

    const url = String(getWSSUrl(locale));
    const subscribes = ['number'];
    const { receiver } = wss({
        url,
        topics,
        locale,
        subscribes,
        activityId,
    });
    useEffect(() => {
        const { data } = receiver;

        if (data) {
            updateTotalFlows(totalFlows, data.totalFlow);
        }
    }, [receiver]);
    //访问量--------end

    //设置结束时间--------start
    const deadlineStrA1 = String(getDateObjS(locale)).replace(/-/g, '/');
    const deadlineStrA2 = String(getDateObjE(locale)).replace(/-/g, '/');
    const deadlineA0 = new Date().getTime();
    const deadlineA1 = new Date(deadlineStrA1).getTime();
    const deadlineA2 = new Date(deadlineStrA2).getTime();
    const [endDay, setEndDay] = useState(0);

    const [isCollectInfo, setIsCollectInfo] = useState(false);

    // 是否展示评论成功弹窗
    const [isCommSuccVisible, setCommSuccVisible] = useState(false);

    const [showDetailsModal_CN, setShowDetailsModal_CN] = useState(false);

    useEffect(() => {
        if (noStartLocaleArr.includes(locale)) {
            //未上线的mm100
            const days1 = Math.round((deadlineA1 - deadlineA0) / oneDayTimes);
            const days = Math.max(days1, 0);
            setEndDay(days);
        } else {
            //已上线的mm100
            const days1 = Math.round((deadlineA2 - deadlineA0) / oneDayTimes);
            const days = Math.max(days1, 0);
            setEndDay(days);
        }
    }, []);
    //设置结束时间--------end

    const preOrderNow = () => {
        if (locale === 'cn') {
            return setShowDetailsModal_CN(true);
        }
        if (['us', 'ca', 'de', 'fr', 'uk', 'jp', 'it', 'es'].includes(locale)) {
            window?.fbq && window?.fbq('track', 'Donate');
        }
        if (['au'].includes(locale)) {
            window?.fbq && window?.fbq('track', 'Contact');
        }
        switch (locale) {
            case 'us':
            case 'ca':
            // return window.open(
            //     `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/on-the-road-power-solution#RV-G`,
            //     '_blank',
            // );
            case 'eu':
            case 'uk':
            case 'de':
            case 'fr':
            case 'it':
            case 'es':
                // gtm.push({
                //     event: 'uaEvent',
                //     event_name: 'click_get_a_quote',
                //     product_name: 'EcoFlow Power Kits',
                //     position: 'introduction',
                //     option_name: 'none',
                // });
                toMM100GetQuote(locale);
                break;
            case 'au':
            case 'kr':
            case 'jp':
                // gtm.push({
                //     event: 'uaEvent',
                //     event_name: 'click_get_a_quote',
                //     product_name: 'EcoFlow Power Kits',
                //     position: 'introduction',
                //     option_name: 'none',
                // });
                setIsCollectInfo(true);
                break;
            case 'cn':
                // gtm.push({
                //     event: 'uaEvent',
                //     event_name: 'click_get_a_quote',
                //     product_name: 'EcoFlow Power Kits',
                //     position: 'introduction',
                //     option_name: 'none',
                // });
                return console.log('TODO: 企业微信二维码弹窗');
            default:
                // gtm.push({
                //     event: 'uaEvent',
                //     event_name: 'click_pre_order',
                //     product_name: 'EcoFlow Power Kits',
                // });
                preCallback?.('1');
        }
    };

    const buyNow = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_pre_order',
            product_name: 'EcoFlow Power Kits',
        });
        if (locale === 'us') {
            window.open('https://www.campervan-hq.com/products/ecoflow-power-kits-5kwh?variant=43873772208381');
            // router.push({ pathname: `/${locale}/power-kits/recommend` });
        } else {
            preCallback?.('1');
        }
    };

    const carouselImgs = swiperImgs['us'];
    const [isLinkVisible, setIsLinkVisible] = useState(false);

    const copyLink = () => {
        const url = window.location.href;
        if (navigator.clipboard && window.isSecureContext) {
            window.navigator.clipboard.writeText(url);
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'absolute';
            textArea.style.opacity = '0';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            new Promise(() => {
                const copyStatus = document.execCommand('copy');
                if (!copyStatus) {
                    message.error('The current browser does not support the automatic copy function, please manually copy in the address bar');
                }
                textArea.remove();
            });
        }
        setIsLinkVisible(true);
        setTimeout(() => {
            setIsLinkVisible(false);
        }, 2000);
    };

    const openCalculatorPage = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_help_me_choose',
            product_name: 'EcoFlow Power Kits',
        });
        window?.fbq && window?.fbq('track', 'CustomizeProduct');
        let calculatorUrl = `/${locale}/calculators/power-kits`;
        if (!location.origin) {
            // ie的一些老版本不兼容
            calculatorUrl = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/${locale}/calculators/power-kits`;
        }
        // 增加name是为了防止点击打开多个calculator/mm100页面
        window.open(calculatorUrl, 'calculators_mm100');
    };

    const handleOpenChatBox = () => {
        const zE = (window as any).zE;
        if (!zE) return;
        zE('messenger:set', 'zIndex', 999999);
        zE('messenger', 'open');

        /** gtm 埋点 --start */
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_ask_me_everything',
            product_name: t('presale.productname'),
        });
        /** gtm 埋点 --end */
    };

    const collectInfoCb = ({ status }: any) => {
        if (status === 'success') {
            setIsCollectInfo(false);
            setCommSuccVisible(true);
        }
        switch (status) {
            case 'success':
                setIsCollectInfo(false);
                setCommSuccVisible(true);
                break;
            case 'close':
                setIsCollectInfo(false);
                break;
        }
    };

    const closeSuccDialog = () => {
        setCommSuccVisible(false);
    };

    useEffect(() => {
        if (presaleState.isQuoteVisible === true) {
            // setIsCollectInfo(true);
            preOrderNow();
        }
    }, [presaleState]);

    return (
        <div className={style.preOrder}>
            {isCollectInfo && <InfoCollection activityId={activityId} cbFunc={collectInfoCb} />}
            {isCommSuccVisible && <SuccessDialog closeSuccDialog={closeSuccDialog} />}
            <div className="prd-order">
                <div className="top-text">
                    {!hideCountry.includes(locale) && <p className="subtit">{t('presale.preorder.title')}</p>}
                    <h1 className="title">{t('presale.productname')}</h1>
                    <p className="title-desc">{t('presale.preorder.productdesc')}</p>
                </div>
                <div className="prd-list">
                    <Swiper
                        modules={[Navigation, Pagination]}
                        pagination={{
                            clickable: true,
                        }}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        loop={true}
                        lazy={true}
                        autoplay={false}
                        id="air-swiper"
                    >
                        {carouselImgs.map((item: any, indx: number) => {
                            return (
                                <SwiperSlide key={indx}>
                                    <div className="swiper-img">
                                        <Image src={item} layout="fill" alt={t('presale.productname')} aria-label={t('presale.productname')}></Image>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
                <div className="interest-visitor">
                    <div className="icon">
                        <EFAvatorIcon />
                    </div>
                    <div>
                        <p className="num">{formatFlow(totalFlows)}</p>
                        <p className="desc">{t('presale.preorder.intrestdesc')}</p>
                        {locale === 'au' && <p className="desc tips">{t('presale.preorder.tips')}</p>}
                    </div>
                </div>
                {!hideCountry.includes(locale) && (
                    <div className="end-time">
                        <div className="icon">
                            <EFAlarmClockIcon />
                        </div>
                        <div>
                            {locale === 'jp' || locale === 'kr' ? (
                                <>
                                    <p className="desc">{t('presale.preorder.saveendin')}</p>
                                    <p className="num">
                                        {endDay}
                                        <span className="union">{t('presale.preorder.days')}</span>
                                    </p>
                                </>
                            ) : (
                                <>
                                    <p className="num">
                                        {endDay}
                                        <span className="union">{t('presale.preorder.days')}</span>
                                    </p>
                                    <p className="desc">{t('presale.preorder.saveendin')}</p>
                                </>
                            )}
                        </div>
                    </div>
                )}
                {['us', 'uk', 'ca', 'de', 'fr', 'eu', 'au', 'cn', 'za', 'it', 'es'].includes(locale) ? (
                    <div className="btns">
                        {locale !== 'cn' && (
                            <Button type="primary" className="order-btn" onClick={buyNow}>
                                {t('presale.bundles.buynow')}
                            </Button>
                        )}
                        {!['za', 'au'].includes(locale) && (
                            <Button className="help-choose" onClick={preOrderNow}>
                                <div className="choose-box">
                                    {/* <div className="text">{['us', 'ca'].includes(locale) ? 'Find Installers' : t('presale.preorder.preordernow')}</div> */}
                                    <div className="text">{t('presale.preorder.preordernow')}</div>
                                </div>
                            </Button>
                        )}
                        {!['sa', 'au'].includes(locale) && (
                            <Button className="help-choose" onClick={openCalculatorPage}>
                                {t('presale.preorder.helpchoose')}
                                <EFRightArrow className="choose-svg" />
                            </Button>
                        )}
                    </div>
                ) : (
                    <div className="btns au-btns">
                        {locale === 'kr' && (
                            <Button type="primary" className="order-btn" onClick={preOrderNow}>
                                {t('presale.preorder.preordernow')}
                            </Button>
                        )}

                        {/* {locale === 'jp' && (
                            <Button type="primary" className="order-btn" onClick={preOrderNow}>
                                {t('presale.preorder.preordernow')}
                            </Button>
                        )} */}

                        {locale !== 'sa' && (
                            <Button className="help-choose" onClick={openCalculatorPage}>
                                {t('presale.preorder.helpchoose')}
                                <EFRightArrow className="choose-svg" />
                            </Button>
                        )}

                        {[''].includes(locale) && (
                            <Button className="help-choose" onClick={handleOpenChatBox}>
                                {t('presale.preorder.Ask_Me_Everything')}
                                <EFAskMeIcon className="choose-svg" />
                            </Button>
                        )}
                    </div>
                )}
                {locale !== 'cn' && (
                    <div className="share-btns">
                        <div className="btn-wrapper fb-icon">
                            <FacebookShareButton
                                url={locationHref}
                                onClick={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'share',
                                        method: 'Facebook',
                                        item_id: t('presale.productname'),
                                    });
                                }}
                            >
                                <FacebookSvg />
                            </FacebookShareButton>
                        </div>
                        {locale !== 'kr' && (
                            <div className="btn-wrapper twitter-icon">
                                <TwitterShareButton
                                    url={locationHref}
                                    onClick={() => {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'share',
                                            method: 'Twitter',
                                            item_id: t('presale.productname'),
                                        });
                                    }}
                                >
                                    <TwitterSvg />
                                </TwitterShareButton>
                            </div>
                        )}
                        <div
                            className="btn-wrapper email-icon"
                            onClick={() => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'share',
                                    method: 'Outlook',
                                    item_id: t('presale.productname'),
                                });
                            }}
                        >
                            <EmailShareButton url={locationHref}>
                                <OutlookSvg />
                            </EmailShareButton>
                        </div>
                        <div
                            className="btn-wrapper link-icon"
                            onClick={() => {
                                copyLink();
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'share',
                                    method: 'CopyLink',
                                    item_id: t('presale.productname'),
                                });
                            }}
                        >
                            <Tooltip
                                title={t('presale.preorder.link_copied')}
                                color={'rgba(22, 93, 225, 0.08)'}
                                placement={'bottom'}
                                visible={isLinkVisible}
                                overlayClassName={style.tooltips}
                            >
                                <LinkSvg />
                            </Tooltip>
                        </div>
                    </div>
                )}
                {locale === 'jp' && (
                    <div className="jp-tip">
                        ※キャンピングカーへの導入をご検討中のお客様には、納品やインストールなどに関してキャンピングカー専門ビルダーのRVランド様をご紹介することが可能です。
                    </div>
                )}
            </div>
            {showDetailsModal_CN && (
                <div className="detailsModal_CN">
                    <div className="mask"></div>
                    <div className="modelBox">
                        <span className="close" onClick={() => setShowDetailsModal_CN(false)}>
                            &times;
                        </span>
                        <p className="title">正浩EcoFlow</p>
                        <p className="text">扫描二维码，添加我的企业微信</p>
                        <div className="qrCodeImg">
                            <Image src="/img/common/qrCode_EF.jpg" layout="fill" className="qrCode qrCode_cn" alt="二维码" aria-label="二维码" />
                        </div>
                        <div className="closeBtn" onClick={() => setShowDetailsModal_CN(false)}>
                            关闭
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
